import { render } from "./are-you-sure.vue?vue&type=template&id=9dcdcd2a&scoped=true"
import script from "./are-you-sure.vue?vue&type=script&lang=js"
export * from "./are-you-sure.vue?vue&type=script&lang=js"

import "./are-you-sure.vue?vue&type=style&index=0&id=9dcdcd2a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2433923721/src/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dcdcd2a"]])

export default __exports__